import axios from "axios";

// Dynamic BACKEND_URL resolution.
// - In production on a custom domain (e.g. edufintr.com), Turkish ISPs often
//   block the default *.emergent.host domain that gets baked into the bundle
//   via REACT_APP_BACKEND_URL at build time. To avoid that, we detect when the
//   app is served from a non-Emergent hostname and fall back to
//   window.location.origin so all API traffic stays on the same domain the
//   user actually reached (no cross-origin call, no DNS block).
// - In local dev / preview (localhost, *.emergentagent.com, *.emergent.host),
//   we keep using REACT_APP_BACKEND_URL as before.
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined" || !window.location) return envUrl;
  const host = window.location.hostname || "";
  const isEmergentHost =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.endsWith(".emergentagent.com") ||
    host.endsWith(".emergent.host");
  if (!isEmergentHost) {
    // Custom domain (e.g. www.edufintr.com) -> use same-origin.
    return window.location.origin;
  }
  return envUrl;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global subscription-expired handler: when the backend returns 402 with
// {code: "subscription_inactive"}, emit a CustomEvent so the SubscriptionGate
// can show a full-screen overlay. We SWALLOW the rejection for this specific
// case so react-error-overlay (dev) doesn't cover the gate. All other errors
// continue to reject as usual.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 402 && detail && typeof detail === "object" && detail.code === "subscription_inactive") {
      try {
        window.dispatchEvent(new CustomEvent("tutorpro:subscriptionInactive", { detail }));
      } catch {}
      // Never resolve so callers relying on awaited data don't run with bogus values.
      return new Promise(() => {});
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatCurrency(value, currency = "TRY") {
  try {
    return new Intl.NumberFormat("tr-TR", { style: "currency", currency, maximumFractionDigits: 2 }).format(value || 0);
  } catch {
    return `${(value || 0).toFixed(2)} ${currency}`;
  }
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
}

export const STATUS_LABELS = {
  scheduled: "Planlandı",
  completed: "Tamamlandı",
  cancelled_paid: "İptal (Ücretli)",
  cancelled_free: "İptal (Ücretsiz)",
  postponed: "Ertelendi",
};

export const STATUS_CLASSES = {
  scheduled: "status-scheduled",
  completed: "status-tamamlandi",
  cancelled_paid: "status-iptal-ucretli",
  cancelled_free: "status-iptal-ucretsiz",
  postponed: "status-ertelendi",
};
